<template>
  <div class="swaychat-attention-grabber swaychat-bounceIn"
    @click="toggleMinimize"
    :style="{
      'border-color': getPrimaryBg
    }" :class="{
      'swaychat-zoomOut': hide
    }">
    <div class="swaychat-attention-grabber-agents" v-if="isOnline">
      <div class="swaychat-operators-avatar swaychat-zoomIn" v-for="agent in agents" :title="agent.nickname" :style="{
        'background-color': agent.uidBg
        }">
        {{ agent.nickname | initial }}
        <img v-if="agent.avatar" :src="makeAliasHost(agent.avatar)" style="display:none" onload="this.style.display = ''" class="swaychat-bounceIn">
      </div>
    </div>
    <div class="swaychat-attention-grabber-message">
      <div class="swaychat-attention-grabber-title">{{ options.title }}</div>
      <div class="swaychat-attention-grabber-subtitle">{{ message }}</div>
    </div>
    <div class="swaychat-form">
      <button-form-component v-if="options.button_type == 'btn'" primary="true" expand="true" :label="options.placeholder"></button-form-component>
      <textarea v-if="options.button_type == 'form'" :placeholder="options.placeholder"></textarea>
    </div>
    <button type="button" class="swaychat-notification-close swaychat-button-close" @click.prevent="close($event)">×</button>
  </div>
</template>

<script>
import {
  uidToColor
} from '../../utils/helpers'

import { mapGetters } from 'vuex'
import ButtonFormComponent from '../input/ButtonFormComponent.vue'

export default {
  filters: {
    initial(value) {
      return value ? value.substring(0,1) : ''
    }
  },
  components: {
    ButtonFormComponent
  },
  props: [
    'options',
    'message',
    'hide',
    'sent'
  ],
  computed: {
    agents() {

      let agent = this.isOnline
      let list = []
      if (agent && this.getAgents)
      for (let i in agent)
        if (this.getAgents[i])
          list.push({
            uidBg: uidToColor(i),
            ...this.getAgents[i]
          })

      return list

    },
    ...mapGetters([
      'getPrimaryBg',
      'getAgents',
      'isOnline'
    ])
  },
  methods: {
    close(e) {
      e.stopPropagation()
      this.$emit('close')
    },
    toggleMinimize() {
      this.$emit('click')
    },
    makeAliasHost (url) {
      const host = '@@UPLOADCARE_ALIAS_HOST';

      return url && url.indexOf('www.ucarecdn.com') !== -1 && host
        ? url.replace('www.ucarecdn.com', host)
        : url;
    }
  }
}

</script>
